import { AxiosInstance } from "axios";
import { apiHost, queryOne } from "../../../shared/technical/rest/restApi";
import { TermsAndConditions } from "./TermsAndConditions";

export function getTermsAndConditions(axios: AxiosInstance, applicationId: string | number): Promise<TermsAndConditions | undefined> {
  return queryOne(axios, `applications/${applicationId}/terms-and-conditions`)
}

export function updateTermsAndConditions(axios: AxiosInstance, applicationId: string | number, termsAndConditions: TermsAndConditions): Promise<void> {
  return axios.put(`${apiHost}/applications/${applicationId}/terms-and-conditions`, termsAndConditions)
}
